import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from "@sentry/angular";

import { appConfig } from './app.config';
import { AppComponent } from './app.component';
import { MessageService } from 'primeng/api';
import type { ToastMessageOptions } from 'primeng/api';

// Make error toasts sticky (do not auto-close) globally.
const makeErrorSticky = (msg: ToastMessageOptions): ToastMessageOptions => {
    if (msg && msg.severity === 'error' && msg.sticky === undefined && msg.life === undefined) {
        return { ...msg, sticky: true };
    }
    return msg;
};
const originalAdd = MessageService.prototype.add;
MessageService.prototype.add = function (message: ToastMessageOptions) {
    return originalAdd.call(this, makeErrorSticky(message));
};
const originalAddAll = MessageService.prototype.addAll;
MessageService.prototype.addAll = function (messages: ToastMessageOptions[]) {
    return originalAddAll.call(this, (messages || []).map(makeErrorSticky));
};

Sentry.init({
    dsn: "https://53c2bc09aa5f7c8d9d9948f683539310@o300968.ingest.us.sentry.io/4510120450064384",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
});
bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
